import React from "react";
import PostCategoriesTable from "../../../components/blog/categories/PostCategoriesTable";
import WrapperSection from "../../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../../components/global/GlobalBreadcrumbs";

const PostCategoriesList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <PostCategoriesTable />
        </WrapperSection>
    );
};

export default PostCategoriesList;
